// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  min-width: 0;
}

.field_defaultdashboard {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

:host ::ng-deep .field_defaultdashboard .p-select {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

:host ::ng-deep .field_defaultdashboard .p-select-label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

:host ::ng-deep .p-select-overlay {
  width: var(--dashboard-select-panel-width) !important;
  min-width: var(--dashboard-select-panel-width) !important;
  max-width: var(--dashboard-select-panel-width) !important;
}

:host ::ng-deep .p-select-option {
  max-width: var(--dashboard-select-panel-width);
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.input-container {
  display: flex;
  width: 100%;
  color: var(--text-color);
}
.input-container .label {
  width: 192px;
  margin-right: 8px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}
.input-container .value {
  flex: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
